import type { CancelContractMarisaTakesCareResponseDTO } from '~/dto/MarisaTakesCare/contractMarisaTakesCare';
import apiAssegurou from '~/services/apiAssegurou';

export async function cancelContractMarisaTakesCareUseCase({
  certificateCode,
  cancelReasonCode,
}: {
  certificateCode: string;
  cancelReasonCode: string;
}): Promise<boolean> {
  try {
    const response =
      await apiAssegurou.post<CancelContractMarisaTakesCareResponseDTO>(
        '/v1/Protecao/CancelarSeguroRedeMaisSaude',
        { codigoCertificado: certificateCode, codMotivo: cancelReasonCode }
      );

    return response.data.success;
  } catch {
    return false;
  }
}
